<template>
  <ul class="eds-accordion" :class="className" :style="style">
    <slot name="accordion" />
  </ul>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Accordion',
    props: {
      className: {
        type: String,
        required: false,
        default: '',
      },
      style: {
        type: Object,
        required: false,
      },
    },
  });
</script>
